import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { WORK } from "@/constants/testIds";

const WORKS = [
  {
    slug: "fintech",
    label: "Fintech",
    title: "A treasury platform for the next billion.",
    tag: "Web · API · Cloud",
    image: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "ai-copilot",
    label: "AI Copilot",
    title: "A multi-agent copilot for ops teams.",
    tag: "AI · LLM · RAG",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "health-app",
    label: "Health",
    title: "A clinical-grade iOS & Android companion.",
    tag: "Mobile · Backend",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "commerce",
    label: "Commerce",
    title: "Headless commerce, 100/100 on Lighthouse.",
    tag: "Web · Design · Edge",
    image: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?auto=format&fit=crop&w=1600&q=80",
  },
];

export default function Work() {
  return (
    <section
      id="work"
      data-testid={WORK.section}
      className="relative py-20 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 md:gap-6 mb-10 md:mb-16">
          <div>
            <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-[#0A84FF] mb-3 md:mb-4">
              Selected work
            </p>
            <h2 className="font-display text-[10vw] sm:text-5xl lg:text-7xl font-black tracking-[-0.03em] leading-[1.02] text-grad">
              Quietly shipped.<br />Loudly performant.
            </h2>
          </div>
          <p className="text-[#a1a1a6] max-w-sm text-sm sm:text-base md:text-lg">
            A sample of recent engagements across AI, fintech, healthcare and commerce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {WORKS.map((w, i) => (
            <motion.a
              key={w.slug}
              href="#contact"
              data-testid={WORK.card(w.slug)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
              className="group relative block rounded-2xl md:rounded-3xl overflow-hidden border border-white/10 aspect-[4/3] md:aspect-[16/11]"
            >
              <img
                src={w.image}
                alt={w.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute top-4 left-4 right-4 md:top-5 md:left-5 md:right-5 flex justify-between items-center">
                <span className="glass rounded-full px-2.5 py-1 md:px-3 md:py-1.5 text-[9px] md:text-[10px] uppercase tracking-[0.2em]">
                  {w.label}
                </span>
                <ArrowUpRight size={18} className="opacity-70 md:opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="absolute bottom-5 left-5 right-5 md:bottom-6 md:left-6 md:right-6">
                <p className="text-[9px] md:text-[10px] uppercase tracking-[0.25em] text-[#0A84FF] mb-1.5 md:mb-2">
                  {w.tag}
                </p>
                <h3 className="font-display text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
                  {w.title}
                </h3>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
